import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-modal-cash-on-delivery-info',
  templateUrl: './modal-cash-on-delivery-info.component.html',
  styleUrls: ['./modal-cash-on-delivery-info.component.scss']
})
export class ModalCashOnDeliveryInfoComponent {
  @Output() cashOnDeliveryInfoNotAgree: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cashOnDeliveryInfoAgree: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cashOnDeliveryInfoNotShowMore: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isModalShow: boolean = false;
  public isDarkBackground: boolean = false;

  show() {
    this.isModalShow = true;
    this.isDarkBackground = true;
  }

  notAgree() {
    this.cashOnDeliveryInfoNotAgree.emit();
    this.closeModal();
  }

  agree() {
    this.cashOnDeliveryInfoAgree.emit();
    this.closeModal();
  }

  agreeNotShowMore() {
    this.cashOnDeliveryInfoNotShowMore.emit();
    this.closeModal();
  }

  closeModal() {
    this.isModalShow = false
    this.isDarkBackground = false;
  }
}
